import { BaseEntity } from '../../../../models';
import { ConfigEmpresaIntegracaoErpEmpresa } from './integracao-erp-empresa';
import { ConfigEmpresaIntegracaoSistemaSCR } from './integracao-sistema-scr';

export class ConfigEmpresa implements BaseEntity {
    readonly id: number;
    idEmpresa: number;
    /** Identificação do nome dos clientes */
    identificacaoCliente: number;
    /** Identificação do nome dos representantes */
    identificacaoRepresentante: number;

    /** Se a empresa controla lançamentos por quantidade */
    controleQuantidade: boolean;
    /** Se a empresa controla lançamentos por peso */
    controlePeso: boolean;
    /** Se a empresa controla lançamentos por valor */
    controleValor: boolean;
    /** Lançamento padrão da empresa */
    lancamento: number;

    /** Se a empresa é exportadora */
    exportadora: boolean;
    moeda: number;
    tipoMercado: number;
    tipoMercadoUnidadeNegocioComLinhaProducao: boolean; // Para quando for o tipo de mercado Unidade de Negócio, verificar se é também com a Linha de Produção
    considerarHistorico: number;
    integracaoErpEmpresas: ConfigEmpresaIntegracaoErpEmpresa[];
    integracaoErpSistema: number;
    IntegracaoErpScr: ConfigEmpresaIntegracaoSistemaSCR; // Config. da integração com o sistema SCR
    logEmailErro: boolean;
    idLocalFaturamentoPadrao: number;

    // Pessoa
    /** Se a empresa realiza o cadastro de pessoas (clientes, representantes e transportadoras) de forma avulsa, ou seja, mesmo que possuam o mesmo código ou CNPJ/CPF vão ser considerados pessoas distintas */
    cadastroAvulsoPessoa: boolean;
    possuiTermoLGPD: boolean;


    /** Flag temporária para identificar qual versão das integrações com os ERPs a empresa está utilizando (V1 Forma antiga / V2 Forma nova) - Após migração de todos os ERPs para a Versão 2, podemos remover este campo */
    versaoIntegracaoErp: number;

    // Acessos
    possuiLocalFaturamento: boolean;
    /** Se a empresa possui clicheria */
    possuiClicheria: boolean;

    // Impostos
    /** Se a empresa aplica IPI em seus produtos */
    aplicaIpi: boolean;

    // Configurações de migração da v1 para a v2
    /** Modo de cadastro das classificações */
    cadastroClassificacao: number;
    /** Modo da central de compras */
    modoCentralCompra: number;
}


/** Verifica se a versão da integração do ERP é a versão 1 */
export function isConfigEmpresaVersaoIntegracaoErp1(configEmpresa: ConfigEmpresa): boolean {
    return configEmpresa?.versaoIntegracaoErp === 1;
}
